module.exports = __webpack_public_path__ + "components/MapControl/svg/Stanowisko archeologiczne.svg?b700d474";


//////////////////
// WEBPACK FOOTER
// ./components/MapControl/svg/Stanowisko archeologiczne.svg
// module id = 2106
// module chunks = 0